<template>
  <v-container id="pagos-pendientes">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-menu ref="fechaMin" v-model="fechaMin" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="fMin" color="gold" label="Fecha desde" readonly v-on="on" />
              </template>
              <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMin = false" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu ref="fechaMax" v-model="fechaMax" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="fMax" color="gold" label="Fecha hasta" readonly v-on="on" />
              </template>
              <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMax = false" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="search"
              :items="jugadores"
              item-value='fullName'
              item-text='fullName'
              :label="'Jugador'"
              color="gold"
              clearable
            >
              <template v-slot:item="{ attrs, item, on }">
                <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.fullName" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="TipoContratoSelec" color="gold" :items="tipoContrato" label="Tipo contrato" clearable return-object item-text="descripcion">
              <template v-slot:itemm="{ attrs, itemm, on }">
                <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title v-text="itemm.descripcion" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="1" class="pl-5">
            <v-btn fab dark small color="indigo" @click="aplicarFiltros">
              <v-icon dark>
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="pagosPendientes.data"
              :page-count="pagosPendientes.last_page"
              :page="pagosPendientes.current_page"
              :server-items-length="pagosPendientes.total"
              :sort-by="sortby"
              :sort-desc="sortdesc"
              :footer-props="{
                itemsPerPageOptions: [10]
              }"
              @update:options="getData($event)"
            >
              <template #item="{ item }">
                <tr>
                  <td class="text-start">
                    {{ item.vencimiento }}
                  </td>
                  <td class="text-start">
                    {{ item.full_name }}
                  </td>
                  <td class="text-start">
                    {{ item.tipoContrato }}
                  </td>
                  <td class="text-start">
                    {{ item.obligacion }}
                  </td>
                  <td class="text-start">
                    {{ setMonto(item) }}
                  </td>
                  <td class="text-end">
                    <v-tooltip content-class="top" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToPagar(item)">
                          mdi-cash-plus
                        </v-icon>
                      </template>
                      <span>Pagar obligación</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'CobrosPendientes',
    data () {
      return {
        headers: [
          { text: 'Vencimiento', align: 'start', sortable: true, value: 'vencimiento' },
          { text: 'Jugador', sortable: true, value: 'full_name' },
          { text: 'Tipo Contrato', value: 'tipoContrato' },
          { text: 'Obligación', value: 'obligacion' },
          { text: 'Cantidad ', value: 'cantidad' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        pagosPendientes: [],
        totales: [],
        terminototales: [],
        tipoContrato: [],
        jugadores: [],
        fechaMax: false,
        fechaMin: false,
        sortby: ['vencimiento'],
        sortdesc: [false],
        TipoContratoSelec: undefined,
        fMin: '',
        fMax: '',
        search: '',
        urlparametrizada: '',
        op: {},
      }
    },
    computed: {},
    watch: {
      urlparametrizada () {
        this.getDataConTotal()
      },
    },
    created () {
      this.getJugadores()
      this.getTiposContratos()
      this.inic()
    },
    methods: {
      setMonto (item) {
        if (item.monetario_sn) {
          return '$ ' + item.cantidad
        } else {
          return item.cantidad
        }
      },
      getUrlParametrizada (page = 1) {
        const tipoContrato = ((this.TipoContratoSelec !== undefined) ? this.TipoContratoSelec.id : '')
        const jugador = ((this.search) ? this.search : '')
        const urlparametrizada = '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&search=' + jugador + '&tipoContrato=' + tipoContrato
        this.urlparametrizada = urlparametrizada
      },
      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      getTiposContratos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_contrato_get' }).then(response => {
          this.tipoContrato = response
        })
      },
      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.sortBy, data.sortDesc)
      },
      getDataConTotal () {
        this.readDataFromAPI(1, this.op.sortBy, this.op.sortDesc)
        // this.getTotal()
      },
      readDataFromAPI: async function (page = 1, sortBy, sortDesc) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/pagos_pendientes' + '?page=' + page + this.urlparametrizada + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc,
        }).then(response => {
          this.pagosPendientes = response
        })
      },
      getTotal (page = 1) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/derechos_pendientes_total/' + this.monedaId + '?page=' + page + this.urlparametrizada,
        }).then(response => {
          this.$emit('cambioTotal', { total: response.toFixed(2), moneda_id: this.monedaId })
        })
      },
      inic () {
        const today = dayjs()
        this.fMin = today.format('YYYY-MM-DD')
        this.fMax = dayjs(today.add(1, 'month')).format('YYYY-MM-DD')
        this.getUrlParametrizada()
      },
      aplicarFiltros () {
        this.getUrlParametrizada()
      },
      goToPagar: function (item) {
        if (item.contrato_id && item.obligacion_representante_id) {
          this.$store.commit('dep/setCuotas', { payload: [item.id] })
          this.$router.push({ name: 'Pagos', params: { id: 0, mode: 'precargado', idJugador: item.jugador_id, idContrato: item.contrato_id, idObligacion: item.obligacion_representante_id } })
        } else {
          this.$router.push({ name: 'Pagos', params: { id: 0, mode: 'precargado', idJugador: item.jugador_id, idContrato: 0, idObligacion: 0, idSolicitud: item.id } })
        }
      },
    },
  }
</script>
